import { render, staticRenderFns } from "./PriceWithButton.vue?vue&type=template&id=106f8800&scoped=true&"
import script from "./PriceWithButton.vue?vue&type=script&lang=js&"
export * from "./PriceWithButton.vue?vue&type=script&lang=js&"
import style0 from "./PriceWithButton.vue?vue&type=style&index=0&id=106f8800&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106f8800",
  null
  
)

export default component.exports